import { Api } from "../api";
import { EXPERIENCE_TYPE } from "redux/Experience/types";
import { PURCHASE_TYPE } from "redux/Booking/types";
import Booking1To1Service from "./Booking1To1Service";
import BookingService from "./BookingService";

export default class BookingFactoryService {
  static createService(
    api: Api,
    type: PURCHASE_TYPE | EXPERIENCE_TYPE
  ): BookingService {
    switch (type) {
      case EXPERIENCE_TYPE.ONE_TO_ONE:
        return new Booking1To1Service(api);
      default:
        return new Booking1To1Service(api);
    }
  }
}
